import { Box, Text } from "@chakra-ui/react";
import React from "react";

const Xvault = () => {

  /*-------------------------------------
  *-------- RENDERED CONTENT ------------
  *------------------------------------*/

  return (
    <React.Fragment>
      <Box w="100%" minHeight="400px">
        <Text color={"colors.white"}>Hey I am the Xvault page </Text>
      </Box>
    </React.Fragment>
  );
};

export default Xvault;